import { createContext } from "react";

export interface IClientContextProps {
  coachClientQuery: any;
  setCoachClientQuery: (coachClientQuery: any) => void;
  resetCoachClientQuery: () => void;
}

export const ClientContext = createContext<IClientContextProps | undefined>(
  undefined,
);
